import RegistrationWrap from './RegistrationWrap';
export default RegistrationWrap;
